import growthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

export const generateImpressionForReduceRecaptcha = () => growthAcquisitionExperiments.get('reduceRecaptcha');

export const previewReduceRecaptcha = () => growthAcquisitionExperiments.preview('reduceRecaptcha');

export const isReduceRecaptchaControlVariant = () => previewReduceRecaptcha() === 'control';

export const isReduceRecaptchaUsabilityVariant = () => previewReduceRecaptcha() === 'usability';

export const isReduceRecaptchaBypassVariant = () => previewReduceRecaptcha() === 'bypass';
